import * as yup from 'yup';

export const schemaCreateUsuario = yup.object().shape({
  IdEmpresa: yup.number().required('ID da empresa é obrigatório'),
  Nome: yup.string().required('Nome é obrigatório'),
  Login: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
  Senha: yup.string().required('Senha é obrigatória')
  .min(6, 'Senha muito curta. Deve ter pelo menos 6 caracteres.'),
  ConfirmacaoSenha: yup.string()
     .oneOf([yup.ref('Senha'), null], 'Senhas devem combinar')
     .required('Confirmação de senha é obrigatória')
});

export const schemaEditUsuario = yup.object().shape({
  Nome: yup.string().required('Nome é obrigatório'),
  Login: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
});